import { AuthService } from './auth.service';
import { Injectable, EventEmitter } from '@angular/core';


//@TODO sprawdzic czy wykorzystywany jest ten serwis bo chyba nie
@Injectable()
export class CoreService {
  refresh: Boolean;
  subscriber: any;

  constructor(
    private authService: AuthService
  ) { 
    this.subscriber = this.authService.getAuthenticatedEmitter().subscribe(
      (auth) => {
        this.refresh = !auth;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/core.service.ts